import { clsx } from "clsx";
import type { FC } from "react";

import { SymbolIcon, TooltipIntent, type TooltipProps } from "widgets";

import style from "../../styles/Cells.module.scss";

import { type ProjectFile } from "../../../../../graphql.js";
import { FILE_BROWSE_TYPES } from "../../../../../settings/settings.js";
import { TooltipController } from "../../../overlays/components/OverlayControllers.js";
import type { BrowsingProjectFileFragment } from "@/modules/files/graphql/files-fragments.gql.js";

export interface IndexStatusIconProps {
  file: ProjectFile | BrowsingProjectFileFragment;
  tooltip?: TooltipProps["content"];
}

const ProtectedFileIcon: FC<IndexStatusIconProps> = (props) => {
  const isDirectory = props.file.fileBrowseType === FILE_BROWSE_TYPES.DIRECTORY;
  const tooltip = `This ${isDirectory ? "folder" : "file"} is protected. Only project managers
     and administrators can edit ${isDirectory ? "files in this folder" : "this file"}. `;

  return (
    props.file.isProtected && (
      <TooltipController content={tooltip} intent={TooltipIntent.Danger}>
        {(tooltipTriggerProps) => (
          <SymbolIcon
            icon={"security"}
            className={clsx(style.cell_file_tag, style.cell_file_tag_error)}
            domProps={tooltipTriggerProps}
          />
        )}
      </TooltipController>
    )
  );
};

export { ProtectedFileIcon };
